import { batch, signal } from "@preact/signals-react"
import {
	acriss,
	acrissCategory,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	priceKpi,
	providers,
	reports,
	singleDate,
	sites,
	transmission, userData, webSuppliers, acrissGroups
} from "@signals"
import { TABLE_TAB_SELECTED } from "Pages/AnalyzersV2/@constants"

export const dateAvailable = signal([])
export const tableTabSelected = signal(TABLE_TAB_SELECTED.MIN)
export const responseData = signal({})
export const isAnalyzerLoading = signal(false)
export const featuresList = signal([])
export const analyzerFilters = signal([])
export const openEvolutionModal = signal({})
export const analyzerChartVisibility = signal([])
export const evolutionChartVisibility = signal([])
export const tableHideDetails = signal(userData.value?.onlyPricesAnalyzerTable)
export const tableHasMainComparison = signal(false)
export const hasNoCurrencyResults = signal(false)
//functions
export const resetSignals = (clearTab) => batch(() => {
	if (clearTab) {
		tableTabSelected.value = TABLE_TAB_SELECTED.MIN
	}
	dateAvailable.value = []
	responseData.value = {}
	featuresList.value = []
	analyzerFilters.value = []
	openEvolutionModal.value = {}
	tableHasMainComparison.value = false
	hasNoCurrencyResults.value = false
})


export const resetCustomFilters = () => batch(() => {
	resetSignals()
	acriss.value = []
	transmission.value = []
	categories.value = []
	fuelPolicy.value = []
	singleDate.value = null
	providers.value = []
	prepaid.value = []
	mileage.value = []
	webSuppliers.value = []
	// the groups are the acriss axis of One Way, and a stale selection would satisfy its
	// mandatory validation with values of another execution
	acrissGroups.value = []
	lengthRental.value = null
	priceKpi.value = false
	inTerminal.value = []
	insurance.value = []
	includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
	acrissCategory.value = false
	sites.value = null
	currency.value = null
	offices.value = null
	reports.value = null
	officesPickoff.value = null
	analyzerDate.value = null
	tableHideDetails.value = userData.value?.onlyPricesAnalyzerTable
})
